"use client";

import useCurrency from "hooks/swr/useCurrency";
import { useBookingSummary } from "./useBookingSummary";
import { usePathname } from "next/navigation";
type Props = {
  onChangeRate: () => void;
};
const PriceBreakdownBlock = ({
  onChangeRate
}: Props) => {
  const {
    formatter,
    rate
  } = useCurrency();
  const {
    daysLength,
    displayedNightlyRate,
    rent,
    taxesAndFees,
    taCommission,
    derivedCommissionRate
  } = useBookingSummary();
  const pathname = usePathname();
  const isPaymentPage = pathname?.startsWith("/payment");
  return <div className='flex w-full flex-col gap-4' data-sentry-component="PriceBreakdownBlock" data-sentry-source-file="PriceBreakdownBlock.tsx">
      <p className='text-[14px] font-semibold leading-none tracking-[-0.14px] text-brand-dark'>
        Price breakdown
      </p>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-2'>
          <p className='flex-1 text-[12px] font-medium leading-none tracking-[-0.12px] text-Gray-700'>
            {formatter(2, 2).format(displayedNightlyRate * rate)} nightly ×{" "}
            {daysLength} {daysLength === 1 ? "night" : "nights"}
          </p>
          <p className='text-right text-[14px] font-medium leading-none tracking-[-0.14px] text-Gray-700'>
            {formatter(2, 2).format(rent * rate)}
          </p>
        </div>
        <div className='flex items-center gap-2'>
          <p className='flex-1 text-[12px] font-medium leading-none tracking-[-0.12px] text-Gray-700'>
            Taxes and fees
          </p>
          <p className='text-right text-[14px] font-medium leading-none tracking-[-0.14px] text-Gray-700'>
            {formatter(2, 2).format(taxesAndFees * rate)}
          </p>
        </div>
        <div className={`flex items-center gap-2 ${isPaymentPage ? "ml-[-7px] mr-[-9px] bg-[#E8FFE9] p-2" : ""} `}>
          <p className='flex-1 text-[12px] font-medium leading-none tracking-[-0.12px] text-Gray-700'>
            Your {derivedCommissionRate}% commission{" "}
            <button type='button' onClick={onChangeRate} className='underline underline-offset-2'>
              Change rate
            </button>
          </p>
          <p className='text-right text-[14px] font-bold leading-none tracking-[-0.14px] text-Emerald-600'>
            {formatter(2, 2).format(taCommission * rate)}
          </p>
        </div>
      </div>
    </div>;
};
export default PriceBreakdownBlock;